import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './styles/global.css';
import App from './App.tsx';
import { ThemeProvider } from './contexts/ThemeContext';
import { initScrollbarActivity } from './lib/scrollbar-activity';
import { fetchBackendVersion, getBackendVersion } from './lib/version';
import { track } from './lib/analytics';
import { initXPixel } from './lib/x-pixel';
import { initMetaPixel } from './lib/meta-pixel';

declare global {
  interface Window {
    __POLYMYTH_BROWSER_UNSUPPORTED__?: boolean;
  }
}

if (!window.__POLYMYTH_BROWSER_UNSUPPORTED__) {
  initScrollbarActivity();

  // Paid-campaign attribution pixels (X + Meta). Each no-ops unless its pixel ID
  // is set (production only), so the third-party scripts never load in dev/staging.
  initXPixel();
  initMetaPixel();

  // Surface unhandled promise rejections to GA4 health monitoring, the React
  // error boundary only catches render errors, not async rejections.
  window.addEventListener('unhandledrejection', (event) => {
    const reason = event.reason;
    track('app_error', {
      message: reason instanceof Error ? reason.message : String(reason),
      name: reason instanceof Error ? reason.name : 'UnhandledRejection',
      context: 'unhandled_rejection',
      backend_version: getBackendVersion(),
    });
  });

  void fetchBackendVersion().then(() => {
    console.info(`[polymyth] backend ${getBackendVersion()}`);
  });

  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <ThemeProvider>
        <App />
      </ThemeProvider>
    </StrictMode>
  );
}
